import React from 'react'
import { makeStyles, } from '@material-ui/styles'

import RootLayout from '~/layout/RootLayout'
import LoginContainer from '~/features/login/LoginContainer'

const LoginView = () => {
  const classes = useStyles()
  return (
    <RootLayout>
      <LoginContainer className={classes.login} />
    </RootLayout>
  )
}

const useStyles = makeStyles(theme => ({
  login: {
    maxWidth: 400,
    width: '100%',
  },
}))

export default React.memo(LoginView)
